import React, { FC } from 'react';
import { GetServerSideProps } from 'next';
import { dehydrate } from 'react-query';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import { PositionJdCustomHead, PositionNotFoundCustomHead } from '@common/customHead';
import JD from '@components/position/jd';
import { fetchPositionMetadata, usePositionMetadata } from '@repository/position/usePosition';
import { queryClient } from '@utils/queryClient';

interface JDPageProps {
  positionSn: number;
}

const PositionDetailJDPage: FC<JDPageProps> = ({ positionSn }) => {
  const { data: metaData, isFetched } = usePositionMetadata(positionSn);

  return (
    <Layout>
      {isFetched && (metaData ? <PositionJdCustomHead metaData={metaData} /> : <PositionNotFoundCustomHead />)}
      <Header />
      <Content>
        <JD />
      </Content>
      <Footer />
    </Layout>
  );
};

export default PositionDetailJDPage;

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const positionSn = isNaN(Number(query.sn)) ? 0 : Number(query.sn);
  await queryClient.prefetchQuery(['position', 'metadata', positionSn], () => fetchPositionMetadata(positionSn));

  return {
    props: {
      positionSn,
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
